import CityPageMosquiteras from "../components/CityPageMosquiteras";

export default function Page() {
  return (
    <CityPageMosquiteras
      name="Estepona"
      slug="estepona"
      cp="29680-29689"
      poblacion={79539}
      zonaGeo="Costa del Sol Occidental"
      lat={36.4276}
      lng={-5.1453}
      zonas={["Centro Histórico", "Cancelada", "Costa Galera"]}
      landmarks={["Plaza de las Flores", "Paseo Marítimo"]}
      municipiosLimitrofes={["Marbella", "Benahavís", "Casares"]}
      festivalLocal="Fiestas Mayores (julio)"
      contextoTipologico="Pueblo blanco con calles floridas (atrae mosquitos), urbanizaciones premium con jardines, residentes expat con altos estándares."
      isCoreZone={true}
    />
  );
}